import React from "react";

import { Summary } from "affinityUI/data/summary";
import { Address, DoB } from "affinityUI/data/valueDisplay";
import { Grid } from "affinityUI/elements/grid";
import { Heading } from "affinityUI/structures/heading";
import { PatientData } from "types/patient";

export const PatientInfo: React.FC<{ patient: PatientData }> = ({ patient }) => {
  return (
    <>
      <Heading>
        <Heading.SectionTitle>Patient details</Heading.SectionTitle>
      </Heading>
      <Grid $cols={[1, 1]}>
        <Summary.List $tight>
          <Summary.Item label="DOB:">
            <DoB value={patient.dateOfBirth} />
          </Summary.Item>
          <Summary.Item label="Hospital number:">{patient.hospitalNumber}</Summary.Item>
          <Summary.Item label="NHS Number:">{patient.nhsNumber}</Summary.Item>
        </Summary.List>
        <Summary.List $tight>
          <Summary.Item label="Oncologist:">{patient.oncologist}</Summary.Item>
          <Summary.Item label="Address:">
            <Address value={patient.contactDetails.address} />
          </Summary.Item>
        </Summary.List>
      </Grid>
    </>
  );
};
